import type { AdminPageGroup } from '@/components/admin/adminPages'
import { AdminMenuItem } from './AdminMenuItem'
import * as S from './AdminMenu.styled'

type AdminMenuGroupProps = {
  group: AdminPageGroup
  activePath: string | null
  onSelect: (path: string) => void
}

export const AdminMenuGroup = ({
  group,
  activePath,
  onSelect,
}: AdminMenuGroupProps) => (
  <S.Group role="group" aria-label={group.label}>
    <S.GroupLabel aria-hidden="true">{group.label}</S.GroupLabel>
    {group.pages.map((page) => (
      <AdminMenuItem
        key={page.path}
        page={page}
        active={page.path === activePath}
        onSelect={onSelect}
      />
    ))}
  </S.Group>
)
